<form [formGroup]="form" class="flex flex-col">
  <div class="mb-8">Aby otrzymać spersonalizowaną ofertę, podaj numer telefonu:</div>
  <mat-form-field appearance="outline" class="mb-16">
    <mat-label>Numer telefonu</mat-label>
    <input formControlName="phoneNumber" matInput mask="000 000 000" prefix="+48 " type="text" />
    <mat-error *ngIf="!form.phoneNumber.untouched && !!form.phoneNumber.errors"> Podaj poprawny numer telefonu </mat-error>
  </mat-form-field>
  <mat-checkbox
    formControlName="contactConsent"
    class="checkbox-label-18 checkbox-label--position-top-absolute mt-6"
    [class.error]="!form.contactConsent.untouched && form.contactConsent.invalid"
  >
    Wyrażam zgodę na przetwarzenie przez Dobry Prąd Sp.&nbsp;z&nbsp;o.o. numeru telefonu poprzez jednorazowy kontakt
    telefoniczny w celu marketingu bezpośredniego swoich produktów lub usług.
    <a class="link" href="" target="_blank">Obowiązek informacyjny</a>
  </mat-checkbox>

  <mat-checkbox
    class="checkbox-label-18 checkbox-label--position-top-absolute mt-16"
    formControlName="passCurrentAgreementTermsConsent"
    [class.error]="!form.passCurrentAgreementTermsConsent.untouched && form.passCurrentAgreementTermsConsent.invalid"
  >
    Chcę otrzymać lepiej dopasowaną ofertę, więc zgadzam się na jednorazowe przekazanie danych nt. moich aktualnych umów
    do Dobry Prąd Sp.&nbsp;z&nbsp;o.o.
  </mat-checkbox>
</form>

<mat-dialog-actions align="start">
  <button color="primary" mat-raised-button type="submit" (click)="prepareOffer()">Przygotuj ofertę</button>
  <button mat-button matDialogClose>Anuluj</button>
</mat-dialog-actions>
